import React, { Suspense, Fragment, lazy } from "react";
import { Routes, Navigate, Route } from "react-router-dom";

import Loader from "./components/Loader/Loader";
import AdminLayout from "./layouts/AdminLayout";

import GuestGuard from "./components/Auth/GuestGuard";
import AuthGuard from "./components/Auth/AuthGuard";
import AdminGuard from "./components/Auth/AdminGuard";

import { BASE_URL } from "./config/constant";
const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            element={
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Element props={true} />
                  )}
                </Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

export const routes = [
  {
    exact: "true",
    guard: GuestGuard,
    path: "/auth/signin-2",
    element: lazy(() => import("./views/auth/signin/SignIn2")),
  },
  {
    exact: "true",
    path: "/404",
    element: lazy(() => import("./views/errors/NotFound404")),
  },
  {
    exact: "true",
    path: "/maintenance/coming-soon",
    element: lazy(() => import("./views/maintenance/ComingSoon")),
  },
  {
    exact: "true",
    path: "/maintenance/error",
    element: lazy(() => import("./views/maintenance/Error")),
  },
  {
    exact: "true",
    path: "/maintenance/offline-ui",
    element: lazy(() => import("./views/maintenance/OfflineUI")),
  },
  {
    exact: "true",
    path: "/auth/signup-1",
    element: lazy(() => import("./views/auth/signup/SignUp1")),
  },
  {
    exact: "true",
    path: "/auth/signup-2",
    element: lazy(() => import("./views/auth/signup/SignUp2")),
  },
  {
    exact: "true",
    path: "/auth/signin-1",
    element: lazy(() => import("./views/auth/signin/SignIn1")),
  },
  {
    exact: "true",
    path: "/auth/signin-2",
    element: lazy(() => import("./views/auth/signin/SignIn2")),
  },
  {
    exact: "true",
    path: "/auth/reset-password-1",
    element: lazy(() => import("./views/auth/reset-password/ResetPassword1")),
  },
  {
    exact: "true",
    path: "/auth/reset-password-2",
    element: lazy(() => import("./views/auth/reset-password/ResetPassword2")),
  },
  {
    exact: "true",
    path: "/auth/change-password",
    element: lazy(() => import("./views/auth/ChangePassword")),
  },
  {
    exact: "true",
    path: "/auth/profile-settings",
    element: lazy(() => import("./views/auth/ProfileSettings")),
  },
  {
    exact: "true",
    path: "/view/otp/:email",
    element: lazy(() => import("./views/auth/reset-password/VerifyOTP")),
  },
  {
    exact: "true",
    path: "/view/verifypass/:token",
    element: lazy(() => import("./views/auth/reset-password/VerifyPass")),
  },
  {
    exact: "true",
    path: "/auth/signout",
    element: lazy(() => import("./views/auth/signin/Logout")),
  },
  {
    exact: "true",
    guard: AuthGuard,
    path: "/auth/tabs-auth",
    element: lazy(() => import("./views/auth/TabsAuth")),
  },
  {
    exact: "true",
    guard: AuthGuard,
    path: "/auth/tabs-auth",
    element: lazy(() => import("./views/auth/TabsAuth")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AdminGuard,
    path: "/help-desk/comp-details",
    element: lazy(() => import("./views/helpdesk/CompanyDash")),
  },

  {
    exact: "true",
    layout: AdminLayout,
    guard: AuthGuard,
    path: "/help-desk/support-requests",
    element: lazy(() => import("./views/helpdesk/SupportRequests")),
  },

  
  {
    path: "*",
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: "true",
        path: "/app/dashboard/analytics",
        element: lazy(() => import("./views/dashboard/DashAnalytics")),
      },
      
      {
        path: "*",
        exact: "true",
        element: () => <Navigate to={BASE_URL} />,
      },
    ],
  },
];

export default renderRoutes;
